module.exports = __webpack_public_path__ + "img/cope-group.81a545e6.svg";